import ElDialog from './src/component'

export default ElDialog



// WEBPACK FOOTER //
// ./src/public/components/el-dialog/index.js